<template>
    <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.88947 20.5H16.1333C16.8881 20.5 17.5 19.8881 17.5 19.1333L17.5 8.14852C17.5 7.80085 17.3654 7.46825 17.1268 7.21652L14.0159 3.93466C13.7516 3.65587 13.3828 3.5 12.9996 3.5H4.88947C4.13441 3.5 3.5 4.09971 3.5 4.86667V19.1333C3.5 19.9003 4.13441 20.5 4.88947 20.5Z" stroke="currentColor"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M3 15H1V1H8.95893L10.8548 3H12.2326L9.65302 0.27864C9.48464 0.101013 9.24776 0 8.9996 0H0.889475C0.398232 0 0 0.388019 0 0.866665V15.1333C0 15.612 0.398231 16 0.889474 16H3V15Z" fill="currentColor"/>
    </svg>
</template>

<script>
export default {
    name: 'SVGCopy',
};
</script>

<style scoped lang="scss">

</style>
